import { render, staticRenderFns } from "./TransportadoraSelector.vue?vue&type=template&id=2cdde933&scoped=true"
import script from "./TransportadoraSelector.vue?vue&type=script&lang=js"
export * from "./TransportadoraSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdde933",
  null
  
)

export default component.exports